import _Set from "@babel/runtime-corejs3/core-js/set";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import { useInstance } from 'intact-vue';
import { useReceive } from '../../hooks/useReceive';
export function useChecked(getNodes) {
  var instance = useInstance();
  var checkedKeys = new _Set();
  instance.on('$receive:checkedKeys', function (v) {
    checkedKeys = new _Set(v);
  });
  useReceive(['data', 'checkedKeys'], refresh);
  function refresh() {
    var nodes = getNodes();
    var uncorrelated = instance.get('uncorrelated');
    var needRecheckNodes = new _Set();
    var loop = function loop(nodes) {
      nodes.forEach(function (node) {
        var key = node.key,
          parent = node.parent;
        var checked = checkedKeys.has(key);
        var shouldUpdateCheckedKeys = false;
        if (parent && !uncorrelated) {
          if (checked && !parent.checked) {
            // need look back
            needRecheckNodes.add(parent);
          } else if (!node.data.disabled) {
            if (checked !== parent.checked) {
              checked = parent.checked;
              // if we use the parent checked status, we should update checkedKeys
              shouldUpdateCheckedKeys = true;
            }
          }
        }
        node.checked = checked;
        if (checked) {
          node.indeterminate = false;
        }
        if (shouldUpdateCheckedKeys) {
          updateCheckedKeys(node);
        }
        if (node.children) {
          loop(node.children);
        }
      });
    };
    loop(nodes);
    needRecheckNodes.forEach(function (node) {
      updateUpward(node);
    });
  }
  function updateCheckedKeys(node) {
    if (node.checked) {
      checkedKeys.add(node.key);
    } else {
      checkedKeys.delete(node.key);
    }
  }
  function toggle(node) {
    var uncorrelated = instance.get('uncorrelated');
    updateDownward(node, !node.checked);
    updateUpward(node.parent);
    instance.set('checkedKeys', _Array$from(checkedKeys));
  }
  function updateDownward(node, checked) {
    node.checked = checked;
    node.indeterminate = false;
    updateCheckedKeys(node);
    if (instance.get('uncorrelated')) return;
    var children = node.children;
    if (children) {
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child.data.disabled) continue;
        updateDownward(child, checked);
      }
    }
  }
  function updateUpward(node) {
    if (instance.get('uncorrelated') || !node) return;
    var checkedCount = 0;
    var count = 0;
    var indeterminate;
    var children = node.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.data.disabled) continue;
      if (child.checked) {
        checkedCount++;
      } else if (child.indeterminate) {
        indeterminate = true;
      }
      count++;
    }
    if (!indeterminate) {
      indeterminate = !!(checkedCount && checkedCount < count);
    }
    node.checked = !!(checkedCount && checkedCount === count);
    node.indeterminate = indeterminate;
    updateCheckedKeys(node);
    updateUpward(node.parent);
  }
  function getCheckedData(leafOnly) {
    var data = [];
    var loop = function loop(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.checked && (!leafOnly || !node.children)) {
          data.push(node.data);
        }
        if (node.children) {
          loop(node.children);
        }
      }
    };
    loop(getNodes());
    return data;
  }
  return {
    toggle: toggle,
    getCheckedData: getCheckedData
  };
}